import React from 'react';
import TeamMember from '../TeamMember';
import './index.css';

const ModernTeam = ({ config }) => {
    const { team } = config;
    return (
        <div id="our_team" className="team-main pad-top-100 pad-bottom-100 parallax">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">
                            <h2 className="block-title team-heading-color text-center">{team.heading}</h2>
                            <p className="title-caption text-center">{team.sub_heading}</p>
                            <div className="modern-testimonials__title-line" />
                        </div>
                        <div className="team-box">
                            <div className="row">
                                {team.members.map((member, index) => (
                                    <TeamMember key={index} member={member} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const CafeTeam = ({ config }) => {
    const { team } = config;
    return (
        <section id="our_team" className="cafe-team pad-top-100 pad-bottom-100">
            <div className="container">
                <div className="cafe-team__header text-center mb-5">
                    <span className="cafe-team__kicker">{team.sub_heading}</span>
                    <h2 className="cafe-team__title">{team.heading}</h2>
                    <div className="cafe-menu__ornament">
                        <span className="cafe-ornament-line" />
                        <span className="cafe-ornament-icon">☕</span>
                        <span className="cafe-ornament-line" />
                    </div>
                    <p className="cafe-team__desc">{team.sub_heading}</p>
                </div>

                <div className="cafe-team__grid">
                    {team.members.map((member, idx) => (
                        <div key={idx} className="cafe-team__card">
                            <div className="cafe-team__img-wrap">
                                <div className="cafe-team__img-circle">
                                    <img src={member.image} alt={member.name} />
                                </div>
                                <div className="cafe-team__badge">
                                    <i className="fa fa-star" />
                                </div>
                            </div>
                            <div className="cafe-team__info">
                                <h4 className="cafe-team__name">{member.name}</h4>
                                <p className="cafe-team__role">{member.role}</p>
                                <div className="cafe-team__social">
                                    <a href="#"><i className="fa fa-instagram" /></a>
                                    <a href="#"><i className="fa fa-twitter" /></a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const TeamSection = ({ config }) => {
    const type = (config.templateType || 'template1').toLowerCase().replace(/-/g, '_');

    switch (type) {
        case 'template14':
        case 'cafe_premium':
            return <CafeTeam config={config} />;
        case 'template15':
        case 'dry_fruits':
        default:
            return <ModernTeam config={config} />;
    }
};

export default TeamSection;
